import PropTypes from 'prop-types';
import { noop } from '../../utils/noop';
import SizeButtons from './SizeButtons/SizeButtons';
import SizeButtonsV2 from './SizeButtons/v2';
import SizeDropdown from './SizeDropdown/SizeDropdown';

const Size = ({
  sizes,
  selectedSize,
  onSizeChange,
  title,
  type,
  variant,
  isSizeChartHidden,
  sizeChartData,
  fomo,
  inDeliveryOptions,
  appCtx,
}) => {
  const isModernLineContainerEnabled = !!appCtx?.siteConfig?.toggles?.isModernLineContainerEnabled;

  if (type === 'dropdown') {
    return (
      <SizeDropdown
        sizes={sizes}
        selectedSize={selectedSize}
        onSizeChange={onSizeChange}
        title={title}
        variant={variant === 'cart' && 'medium'}
      />
    );
  }

  if (isModernLineContainerEnabled) {
    return (
      <SizeButtonsV2
        sizes={sizes}
        selectedSize={selectedSize}
        onSizeChange={onSizeChange}
        title={title}
        isSizeChartHidden={isSizeChartHidden}
        sizeChartData={sizeChartData}
        fomo={fomo}
        inDeliveryOptions={inDeliveryOptions}
      />
    );
  }

  return (
    <SizeButtons
      sizes={sizes}
      selectedSize={selectedSize}
      onSizeChange={onSizeChange}
      title={title}
      isSizeChartHidden={isSizeChartHidden}
      sizeChartData={sizeChartData}
      fomo={fomo}
      inDeliveryOptions={inDeliveryOptions}
    />
  );
};

Size.defaultProps = {
  sizes: [],
  onSizeChange: noop,
  title: 'Selection Talla',
  type: '',
  selectedSize: undefined,
  variant: '',
  isSizeChartHidden: false,
  sizeChartData: {},
  fomo: {},
  inDeliveryOptions: false,
  appCtx: {},
};

Size.propTypes = {
  sizes: PropTypes.arrayOf(PropTypes.object),
  onSizeChange: PropTypes.func,
  title: PropTypes.string,
  type: PropTypes.string,
  selectedSize: PropTypes.string,
  variant: PropTypes.string,
  isSizeChartHidden: PropTypes.bool,
  sizeChartData: PropTypes.object,
  fomo: PropTypes.object,
  inDeliveryOptions: PropTypes.bool,
  appCtx: PropTypes.object,
};

export default Size;
